import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import employees from './slices/employees'
import supplements from './slices/supplements'
import modals from './slices/modalsSlice';
import paiements from './slices/paiements';
import authorizations from "./slices/authorizationSlice";
import agesection from './slices/agesectionsSlice';
import expensetype from './slices/expensetypes';
import classes from './slices/classesSlice' ;
import children from './slices/childrenSlice';
import categorie from './slices/subscriptionCategorySlice'
import financesReducer from './slices/financesSlice'
import expenses from './slices/expenses';

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        employees,
        supplements,
        modals,
        paiements,
        authorizations,
        agesection,
        expensetype,
        categorie,
        classes,
        children,
        expenses,
        financesReducer,

        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
